const formatName = (name: { first?: string; last?: string }) => {
  return [name?.first ?? "", name?.last ?? ""].join(" ").trim();
};

export default formatName;
